import { cn } from "@/lib/utils";

type Props = {
  title: string;
  subtitle?: React.ReactNode;
  titleClassName?: string;
  subtitleClassName?: string;
};

/** Shared title/subtitle block reused across the login page views for a consistent look. */
export const ViewHeading = ({ title, subtitle, titleClassName, subtitleClassName }: Props) => (
  <>
    <h2 className={cn("text-[clamp(1.5rem,2vw,2.25rem)] font-extrabold text-[#111827] mb-1", titleClassName)}>
      {title}
    </h2>
    {subtitle && (
      <p className={cn("text-[clamp(0.875rem,1vw,1.1rem)] text-[#6B7280] mb-7 leading-[1.6]", subtitleClassName)}>
        {subtitle}
      </p>
    )}
  </>
);
